import VueRouter from 'vue-router'

import TokenService from './services/storage.service'

import DashboardLayout from '@/layouts/DashboardLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'

// Dashboard pages
import Assortment from '@/pages/Dashboard/Assortment.vue'
import AssortmentParameter from '@/pages/Dashboard/AssortmentParameter.vue'
import Users from '@/pages/Dashboard/Users.vue'
import Nodes from '@/pages/Dashboard/Nodes.vue'
import Branches from '@/pages/Dashboard/Branches.vue'
import Clusters from '@/pages/Dashboard/Clusters.vue'
import Cluster from '@/pages/Dashboard/Cluster.vue'
import Clients from '@/pages/Dashboard/Clients.vue'
import Products from '@/pages/Dashboard/Products.vue'
import Restocking from '@/pages/Dashboard/Restocking.vue'
import Sales from '@/pages/Dashboard/Sales.vue'
import Stock from '@/pages/Dashboard/Stock.vue'
import Solicitations from '@/pages/Dashboard/Solicitations.vue'
import BranchParamsDefault from '@/pages/Dashboard/BranchParamsDefault.vue'
import ProductSimulation from '@/pages/Dashboard/ProductSimulation.vue'
import BranchParamsSimulation from '@/pages/Dashboard/BranchParamsSimulation.vue'
import DCParamsSimulation from '@/pages/Dashboard/DCParamsSimulation.vue'
import UserProfile from '@/pages/Dashboard/UserProfile.vue'
import BranchesRelationship from '@/pages/Dashboard/BranchesRelationship.vue'
import RestockingAmplitude from '@/pages/Dashboard/RestockingAmplitude.vue'
import Ranking from '@/pages/Dashboard/Ranking.vue'
import DemandsManagement from '@/pages/Dashboard/DemandManagement.vue'
import RestockingProductManagement from '@/pages/Dashboard/RestockingProductManagement.vue'
import RestockingStoreManagement from '@/pages/Dashboard/RestockingStoreManagement.vue'
import Solicitation from '@/pages/Dashboard/Solicitation/Solicitation.vue'

// Auth pages
import LoginV2 from '@/pages/Auth.v2/Login.vue'
import LockV2 from '@/pages/Auth.v2/Lock.vue'

import AuthService from './services/auth.service'

const routes = [
    {
        path: '/',
        redirect: '/assortment'
    },
    {
        path: '/',
        component: AuthLayout,
        name: 'Authentication',
        children: [
            {
                path: '/login',
                name: 'Login',
                component: LoginV2,
                meta: {
                    public: true, // Allow access to even if not logged in
                    onlyWhenLoggedOut: true
                }
            },
            {
                path: '/lock',
                name: 'Lock',
                component: LockV2
            }
        ]
    },
    {
        path: '/restocking/ranking/:amplitude',
        props: true,
        name: 'Ranking',
        component: Ranking,

        meta: {
            public: true // Allow access to even if not logged in
        }
    },
    {
        path: '/restocking/assortment-parameter/:branch',
        props: true,
        name: 'Parametrização de Produtos',
        component: AssortmentParameter,

        meta: {
            public: true // Allow access to even if not logged in
        }
    },
    {
        path: '/public/solicitation',
        name: 'Criar Pedido',
        component: Solicitation,
        props: true,
        meta: {
            public: true
        }
    },
    {
        path: '/',
        component: DashboardLayout,
        children: [
            {
                path: '/assortment',
                name: 'Análise da Qualidade do Sortimento',
                component: Assortment
            },
            {
                path: '/branches',
                name: 'Filiais',
                component: Branches
            },
            {
                path: '/clients',
                name: 'Clientes',
                component: Clients
            },
            {
                path: '/clusters',
                name: 'Clusters',
                component: Clusters
            },
            {
                path: '/clusters/:id',
                name: 'Cluster',
                component: Cluster
            },
            {
                path: '/nodes',
                name: 'Árvore de Sortimento',
                component: Nodes
            },
            {
                path: '/products',
                name: 'Produtos',
                component: Products
            },
            {
                path: '/users',
                name: 'Usuários',
                component: Users
            },
            {
                path: '/restocking',
                name: 'Reposição Dinâmica',
                component: Restocking
            },
            {
                path: '/sales',
                name: 'Vendas',
                component: Sales
            },
            {
                path: '/stock',
                name: 'Estoque',
                component: Stock
            },
            {
                path: '/product-simulation/:productId',
                props: true,
                name: 'Simulação por Produto',
                component: ProductSimulation
            },
            {
                path: '/branch-params/:productId',
                props: true,
                name: 'Parâmetros de Padrão por Loja',
                component: BranchParamsDefault
            },
            {
                path: '/branch-params-simulation/:simulationId',
                props: true,
                name: 'Parâmetros de Simulação por Loja',
                component: BranchParamsSimulation
            },
            {
                path: '/dc-params/:productId',
                props: true,
                name: 'Parâmetros de Padrão por CD',
                component: DCParamsSimulation
            },
            {
                path: '/dc-params-simulation/:simulationId',
                props: true,
                name: 'Parâmetros de Simulação por CD',
                component: DCParamsSimulation
            },
            {
                path: '/branches-relationship',
                name: 'Relationamento de Filiais e CDs',
                component: BranchesRelationship
            },
            {
                path: '/restocking-amplitude',
                name: 'Parametrização da Amplitude do Mix',
                component: RestockingAmplitude
            },
            {
                path: '/solicitations',
                name: 'Pedidos',
                component: Solicitations
            },
            {
                path: '/demands-management',
                name: 'Gestão de Demanda',
                component: DemandsManagement
            },
            {
                path: '/restocking-product-management',
                name: 'Gestão da Reposição Dinâmica - Produto',
                component: RestockingProductManagement
            },
            {
                path: '/restocking-store-management',
                name: 'Gestão da Reposição Dinâmica - Loja',
                component: RestockingStoreManagement
            },
            {
                path: '/solicitation/:solicitationType',
                name: 'Pedido',
                component: Solicitation,
                props: true
            },
        ]
    }
]

// configure router
const router = new VueRouter({
    routes, // short for routes: routes
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    },
    linkExactActiveClass: 'nav-item active'
    //mode: 'hash'
})

router.beforeEach(async (to, from, next) => {
    /**
     * Access control
     */
    const isPublic = to.matched.some(record => record.meta.public)
    const onlyWhenLoggedOut = to.matched.some(
        record => record.meta.onlyWhenLoggedOut
    )
    const loggedIn = !!TokenService.getToken()
    const isLocked = TokenService.getToken()
        ? TokenService.getToken().length < 20
        : false

    if (from.meta?.public && !from.meta?.onlyWhenLoggedOut && to.path !== '/login') {
        return false
    }

    if (!isPublic && !loggedIn) {
        return next({
            path: '/login',
            query: { redirect: to.fullPath } // Store the full path to redirect the user to after login
        })
    }

    if (!isPublic && loggedIn) {
        const me = await AuthService.me()
        if (!me.data?.groups?.includes("Planejador")) {
            return false
        }
    }

    if (
        !isPublic &&
        isLocked &&
        router.currentRoute.path != '/lock' &&
        to.path != '/lock'
    ) {
        return next({
            path: '/lock',
            query: { redirect: to.fullPath } // Store the full path to redirect the user to after login
        })
    }

    // Do not allow user to visit login page or register page if they are logged in
    if (loggedIn && onlyWhenLoggedOut) {
        return next('/')
    }

    /**
     * Page title customization
     */
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched
        .slice()
        .reverse()
        .find(r => r.name)

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle)
        document.title =
            nearestWithTitle.name + ' - ' + process.env.VUE_APP_NAME

    next()
})

export default router
